// extracted by mini-css-extract-plugin
module.exports = {"infoGuiaContainer":"infoGuia_infoGuiaContainer__zvoAh","headerGuiaActividad":"infoGuia_headerGuiaActividad__2V9Qr"};